// extracted by mini-css-extract-plugin
export default {"socialButtonWrapper":"SSOButton_socialButtonWrapper__vnKBA"};